import { computed, ref, getCurrentInstance } from "vue-demi";
import { defineStore } from "pinia";

export const useAppStore = defineStore("app", () => {
  const vm = getCurrentInstance().proxy;
  const userData = ref({});
  const userRole = ref("");
  const selectedCustomer = ref("");
  const loadingCustomer = ref(true);
  const isCustomer = computed(() => {
    const result = [];

    // İstenilen şart
    const condition = (item) => item === true;

    // ŞART 1 => Kullanıcı tipine göre
    vm.$ability.can("view", "asl-customer-select") ? result.push(true) : result.push(false);

    // ŞART 2 => Müşteri seçimi yapıldımı
    selectedCustomer.value === "" || typeof selectedCustomer.value === "undefined"
      ? result.push(true)
      : result.push(false);

    return result.every(condition);
  });

  const isMngr = computed(() => {
    const result = [];

    // İstenilen şart
    const condition = (item) => item === true;

    // ŞART 1 => Kullanıcı tipine göre
    vm.$ability.can("view", "asl-customer-select") ? result.push(true) : result.push(false);

    return result.every(condition);
  });

  return {
    userData,
    userRole,
    selectedCustomer,
    loadingCustomer,
    isCustomer,
    isMngr,
  };
});
